import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "@/gestionale/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/gestionale/components/ui/card";
import { Mail, AlertCircle } from "lucide-react";

// @ts-ignore - process.env è iniettato a build time da CRA (webpack DefinePlugin)
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

export default function ConfermaInvito() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  const token = searchParams.get("token");
  const type = searchParams.get("type") || "invite";
  const redirectTo = searchParams.get("redirect_to") || `${window.location.origin}/reset-password`;

  const handleContinue = () => {
    if (!token) {
      setError("Link non valido o incompleto. Richiedi un nuovo invito.");
      return;
    }
    const verifyUrl = `${SUPABASE_URL}/auth/v1/verify?token=${encodeURIComponent(token)}&type=${encodeURIComponent(type)}&redirect_to=${encodeURIComponent(redirectTo)}`;
    window.location.href = verifyUrl;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-primary" />
            {type === "invite" ? "Sei stato invitato" : "Recupero password"}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {type === "invite"
              ? "Clicca il pulsante per creare la tua password e accedere al gestionale."
              : "Clicca il pulsante per impostare una nuova password."}
          </p>

          {error && (
            <div className="flex items-center gap-2 p-3 rounded-lg bg-destructive/10 text-destructive text-sm">
              <AlertCircle className="h-4 w-4 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <Button onClick={handleContinue} className="w-full" disabled={!token}>
            Continua
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}